export const actionTypes = {
  TRANSPORT_ORDER_SET_FILTER: 'TRANSPORT_ORDER_SET_FILTER',
};

export default actionTypes;
